import { THEMES } from 'src/constants';
import { softShadows } from '../shadows';

export default {
  name: THEMES.SUN_FLOWER,
  light: {
    palette: {
      type: 'light',
      background: {
        default: '#FAFAFA',
        paper: '#FFFFFF',
        navbar: '#F0B00A',
        dark: '#f4f6f8'
      },
      primary: {
        main: '#F0B00A',
        contrastText: 'rgba(255,255,255,0.87)'
      },
      secondary: {
        main: '#F0B00A',
        contrastText: 'rgba(255,255,255,0.87)'
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.87)',
        secondary: 'rgba(0, 0, 0, 0.6)',
        disabled: 'rgba(0, 0, 0, 0.38)'
      }
    },
    shadows: softShadows
  },
  dark: {
    palette: {
      type: 'dark',
      background: {
        default: '#303030',
        navbar: '#F0B00A',
        paper: '#424242',
        dark: '#303030'
      },
      primary: {
        main: '#F0B00A',
        contrastText: 'rgba(255,255,255,0.87)'
      },
      secondary: {
        main: '#F0B00A',
        contrastText: 'rgba(255,255,255,0.87)'
      },
      text: {
        primary: '#FFFFFF',
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)'
      }
    },
    shadows: softShadows
  }
};
